import React from "react";

import ImageUploader from "../ImageUploader/ImageUploader";
import Label from "./Label";

import styles from "./Field.module.scss";

const ImageField = React.forwardRef(
  ({ errors, id, description, isRequired, label, onChange, src }, ref) => {
    const isInvalid = errors[id] ? "is-invalid" : "";

    return (
      <div className={styles.formGroup}>
        <Label id={id} label={label} isRequired={isRequired} />
        <input type="hidden" className={`${isInvalid}`} />
        <ImageUploader src={src} onChange={onChange} />
        <span className={`d-block ${styles.description}`}>{description}</span>
        {errors[id] && <div className="invalid-feedback">This field is required.</div>}
      </div>
    );
  }
);

export default ImageField;
